{
  "header": {
    "title": "Explorador de datos",
    "description": "Crea, gestiona y analiza encuestas para empleados para obtener información más profunda",
    "createButton": "Crear nuevo informe"
  },
  "content": {
    "searchInput": {
      "placeholder": "Buscar encuestas"
    },
    "tagsDropdown": {
      "triggerLabel": "Etiquetas",
      "placeholder": "Buscar una etiqueta",
      "options": {
        "employeeEngagement": "Compromiso del empleado",
        "workplaceCulture": "Cultura laboral",
        "teamSatisfaction": "Satisfacción del equipo",
        "performanceFeedback": "Retroalimentación del rendimiento",
        "organizationalImprovement": "Mejora organizacional",
        "usa": "EE.UU.",
        "europe": "Europa",
        "asia": "Asia",
        "ukraine": "Ucrania"
      }
    }
  },
  "columns": {
    "reportName": "Nombre del informe",
    "tags": "Etiquetas",
    "creator": "Creador",
    "status": "Estado"
  },
  "detailsPage": {
    "header": {
      "backButton": "Volver al explorador de datos",
      "description": "Crea, gestiona y analiza encuestas para empleados para obtener información más profunda",
      "shareReportButton": "Compartir informe",
      "editReportButton": "Editar informe"
    },
    "cardMetrcisSection": {
      "title": "Prom. de empleados"
    },
    "leaderMetrcisSection": {
      "title": "Métricas del líder",
      "description": "Este gráfico muestra cómo respondieron los empleados con diferentes años de antigüedad a la afirmación.",
      "chart": {
        "title": "Puntuación de satisfacción laboral"
      }
    }
  },
  "builder": {
    "header": {
      "backButton": "Volver al explorador de datos",
      "addDescriptionButton": "Agregar descripción",
      "cancelButton": "Cancelar",
      "saveReportButton": "Guardar informe"
    },
    "content": {
      "notSupportedLayout": "Diseño 1/3 no compatible",
      "inputs": {
        "dateRange": {
          "label": "Rango de fechas"
        },
        "department": {
          "label": "Departamento"
        },
        "leader": {
          "label": "Líder"
        },
        "gender": {
          "label": "Género"
        },
        "location": {
          "label": "Ubicación"
        },
        "tenure": {
          "label": "Antigüedad"
        }
      },
      "charts": {
        "heatmap": {
          "title": "Intensidad por departamento"
        },
        "distribution": {
          "title": "Distribución de respuestas"
        },
        "improvement": {
          "title": "Top 5 de preguntas con mejora en el equilibrio vida-trabajo"
        },
        "decline": {
          "title": "Top 5 de preguntas con disminución en el equilibrio vida-trabajo"
        },
        "text": {
          "title": "Métricas del líder",
          "description": "Resumen del rendimiento y comentarios del líder"
        }
      }
    },
    "sidebar": {
      "text": {
        "textHeading": {
          "title": "Encabezado",
          "description": "Total de empleados en la encuesta",
          "data": {
            "title": "Métricas del líder",
            "description": "Resumen de métricas de rendimiento y retroalimentación del líder"
          }
        },
        "textSubtitle": {
          "title": "Subtítulo",
          "description": "Total de empleados en la encuesta",
          "data": {
            "title": "Métricas del líder",
            "description": "Resumen de métricas de rendimiento y retroalimentación del líder"
          }
        },
        "textBodyText": {
          "title": "Texto del cuerpo",
          "description": "Total de empleados en la encuesta",
          "data": {
            "title": "Métricas del líder",
            "description": "Resumen de métricas de rendimiento y retroalimentación del líder"
          }
        }
      },
      "numbers": {
        "numbersAvgEmployee": {
          "title": "Prom. de empleados",
          "description": "Total de empleados en la encuesta",
          "data": {
            "title": "Prom. de empleados",
            "description": "Total de empleados en la encuesta"
          }
        },
        "numbersResponseCount": {
          "title": "Cantidad de respuestas",
          "description": "Número de respuestas enviadas",
          "data": {
            "title": "Cantidad de respuestas",
            "description": "Número de respuestas enviadas"
          }
        },
        "numbersParticipationRate": {
          "title": "Tasa de participación",
          "description": "Porcentaje de empleados que respondieron",
          "data": {
            "title": "Tasa de participación",
            "description": "Porcentaje de empleados que respondieron"
          }
        },
        "numbersAverageScore": {
          "title": "Puntuación media",
          "description": "Porcentaje de empleados que respondieron",
          "data": {
            "title": "Puntuación media",
            "description": "Porcentaje de empleados que respondieron"
          }
        },
        "numbersEnps": {
          "title": "eNPS",
          "description": "Porcentaje de empleados que respondieron",
          "data": {
            "title": "eNPS",
            "description": "Porcentaje de empleados que respondieron"
          }
        }
      },
      "graphs": {
        "graphsAvgEmployee": {
          "title": "Prom. de empleados",
          "description": "Total de empleados en la encuesta",
          "data": {
            "title": "Prom. de empleados",
            "description": "Total de empleados en la encuesta"
          }
        }
      }
    }
  }
}
